/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-06-17 11:21:45
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-01-18 17:56:49
 * @FilePath: /unifyxp-v2-store-portal/src/components/Modules/Components/ContentImageDragItem/index.tsx
 */
import CountWords from '@/src/components/CountWords/CountWords';
import ItemWrapper from '@/src/constrains/SalesChannelPreviewPageComponents/OverwriteItemWrapper';
import Section from '@/src/constrains/SalesChannelPreviewPageComponents/SectionContainer';
import classname from 'classnames';
import React, { useState } from 'react';
import { Input, Select, TextArea } from 'src/components/Antd';
import Image from 'src/components/DragRowDisplay/Image';
import css from './css.module.less';
import { get } from 'lodash';

const ContentDragItem = (props) => {
  const {
    index,
    contentPageList,
    isList,
    summary,
    subtitle,
    image,
    contentPage = {},
    onDelete,
    onChange,
    specificError = {},
    errKeys = {},
    selectedPages,
    topPart,
    sectionContainer,
    isPrimary,
    salesChannelUuid,
    currentSalesChannelUuid,
  } = props;

  const salesChannels = Object.values(selectedPages || {})
    .filter((i) => i)
    .map((i) => {
      const salesChannel = get(i, 'salesChannel');
      const uuid = get(salesChannel, 'uuid');
      const name = get(salesChannel, 'name');
      return {
        label: name,
        value: uuid,
      };
    });

  const [contentUuid, setContentUuid] = useState((contentPage || {}).uuid);

  const [_salesChannelUuid, setSalesChannelUuid] = useState(
    salesChannelUuid || currentSalesChannelUuid,
  );

  const contentPageOptions = (selectedSalesChannelUuid) => {
    return get(selectedPages, `${selectedSalesChannelUuid}.contentPages`) || [];
  };

  const handleOnSubtitleChange = (subtitle) => {
    if (onChange) {
      onChange(index, { subtitle });
    }
  };

  const handleOnSummaryChange = (summary) => {
    if (onChange) {
      onChange(index, { summary });
    }
  };

  const handleOnSalesChannelUuidChange = async (salesChannelUuid) => {
    setSalesChannelUuid(salesChannelUuid);
    setContentUuid(null);
    if (onChange) {
      onChange(index, { salesChannelUuid });
    }
  };

  const handleOnImageChange = (image) => {
    if (onChange) {
      onChange(index, { image });
    }
  };

  const handleOnContentPageChange = (contentPageUuid) => {
    const { inUsePages, pendingPages, previousPages } = contentPageList || {};
    const list = contentPageOptions(_salesChannelUuid) || [
      ...inUsePages,
      ...pendingPages,
      ...previousPages,
    ];
    const t = list.find((i) => i.uuid === contentPageUuid);

    if (onChange) {
      onChange(index, {
        contentPage: t,
        summary: (t.summary || '').slice(0, 120),
        // subtitle: (t.subtitle || '').slice(0, 40),
      });
    }
    setContentUuid(contentPageUuid);
  };

  const handleOnDelete = () => {
    if (onDelete) {
      onDelete(index);
    }
  };

  const getErr = (key) => {
    //console.log(specificError);
    return specificError[errKeys[key]] || [];
  };

  return (
    <React.Fragment>
      <Section className={`${css.section2} ${sectionContainer || ''}`}>
        {topPart || null}
        <Image
          onDelete={onDelete ? handleOnDelete : null}
          title='Image*'
          subtitle='Tip - recommended ratio 7:8'
          imgOnChange={handleOnImageChange}
          linkImage={image}
          error={
            getErr(errKeys.image).length > 0
              ? getErr(errKeys.image).join(' ')
              : ''
          }
          className={classname(css.allContainer)}
          className2={classname(css.imageContainer)}
          topPart={
            <div className={css.sectionInputs}>
              {salesChannels.length > 1 && (
                <ItemWrapper title={`Sales Channels*`}>
                  <Select
                    placeholder='Select Sales Channels'
                    disabled={!isPrimary}
                    optionsList={salesChannels}
                    value={_salesChannelUuid}
                    filterOption={(input, option) =>
                      option.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                    showSearch
                    optionFilterProp='label'
                    onChange={handleOnSalesChannelUuidChange}
                    size='large'
                    error={getErr(errKeys.salesChannelUuid).length > 0}
                    help={getErr(errKeys.salesChannelUuid).join(' ')}
                  />
                </ItemWrapper>
              )}
              <ItemWrapper title={`Content Page ${index + 1}*`}>
                <Select
                  placeholder='Select Content Page'
                  disabled={!isPrimary}
                  optionsList={contentPageOptions(_salesChannelUuid).map(
                    (i) => {
                      const { uuid, name } = i;
                      return {
                        label: name,
                        value: uuid,
                      };
                    },
                  )}
                  value={contentUuid}
                  filterOption={(input, option) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  } //contentPageInvalid
                  showSearch
                  optionFilterProp='label'
                  onChange={handleOnContentPageChange}
                  size='large'
                  error={
                    getErr(errKeys.contentPage).length > 0 ||
                    getErr(errKeys.contentPageInvalid).length > 0
                  }
                  help={
                    getErr(errKeys.contentPage).join(' ') +
                    getErr(errKeys.contentPageInvalid).join(' ')
                  }
                />
              </ItemWrapper>
              {!isList && (
                <ItemWrapper
                  rightPart={
                    <CountWords count={(subtitle || '').length} allCount={40} />
                  }
                  title='Content Page Subtitle*'>
                  <Input
                    size='large'
                    maxLength={40}
                    value={subtitle}
                    onChange={handleOnSubtitleChange}
                    error={getErr(errKeys.subtitle).length > 0}
                    help={getErr(errKeys.subtitle).join(' ')}
                  />
                </ItemWrapper>
              )}
              <ItemWrapper
                rightPart={
                  <CountWords count={(summary || '').length} allCount={120} />
                }
                title='Content Page Summary*'>
                <TextArea
                  maxLength={120}
                  value={summary}
                  onChange={handleOnSummaryChange}
                  error={getErr(errKeys.summary).length > 0}
                  help={getErr(errKeys.summary).join(' ')}
                />
              </ItemWrapper>
            </div>
          }
        />
      </Section>
    </React.Fragment>
  );
};
export default ContentDragItem;
